import redirect from "@rill/redirect";
import rill from "rill";
import ensurePaid from "../middleware/ensure-paid";

import ensureUser from "../middleware/ensure-user";
import maintenanceMode from "../middleware/maintenance-mode";
import AccessDenied from "./access-denied";
import AddToCalendar from "./add-to-calendar";
import Admin from "./admin";
import AthletePortal from "./athlete-portal";
import BookTour from "./book-tour";
import CoachBilling from "./coach-billing";
import CoachingPortal from "./coaching-portal";
import Dashboard from "./dashboard";
import Docs from "./docs/docs";
import Feedback from "./feedback";
import Forgot from "./forgot";
import Login from "./login";
import LoginNewOnboarding from "./login-new-onboarding";
import Maintenance from "./maintenance";
import NotFound from "./not-found";
import Onboarding from "./onboarding";
import OnboardingBranding from "./onboarding-branding";
import OnboardingExerciseLibrary from "./onboarding-exercise-library";
import PerformBilling from "./perform-billing";
import PrivacyPolicy from "./privacy-policy";
import Setup from "./setup";
import Share from "./share";
import Signup from "./signup";
import SignupCoachOrganization from "./signup-coach-organization";
import TermsOfUse from "./terms-of-use";
import UpdatePassword from "./update-password";
import Upgrade from "./upgrade";
import Upgrade1 from "./upgrade-1";

const Views = (app) => {
  app
    /**
     * Provde domain ownership for "loader.io" which does load testing.
     * http://loader.io/
     */
    .get(
      "/loaderio-bf33d659bfd5b75e1bc28d209e05f988",
      ({ res }) => (res.body = "loaderio-bf33d659bfd5b75e1bc28d209e05f988")
    ) //prod
    .get(
      "/loaderio-0b764bc163b14b5b7952b98998604505",
      ({ res }) => (res.body = "loaderio-0b764bc163b14b5b7952b98998604505")
    ) //staging
    .get(
      "/loaderio-f0fcb8e10671d36b70334d3da7545673",
      ({ res }) => (res.body = "loaderio-f0fcb8e10671d36b70334d3da7545673")
    ) //CP
    .get(maintenanceMode)
    .get("/", redirect("/coaching-portal"))
    .setup(Admin)
    .setup(Login)
    .setup(LoginNewOnboarding)
    .setup(Forgot)
    .setup(Signup)
    .setup(SignupCoachOrganization)
    .setup(Onboarding)
    .setup(OnboardingBranding)
    .setup(OnboardingExerciseLibrary)
    .setup(UpdatePassword)
    .setup(Setup)
    .setup(AthletePortal)
    .setup(Dashboard)
    .setup(CoachingPortal)
    .setup(Share)
    .setup(BookTour)
    .setup(NotFound)
    .setup(AccessDenied)
    .setup(PrivacyPolicy)
    .setup(TermsOfUse)
    .setup(Feedback)
    .setup(Upgrade)
    .setup(Upgrade1)
    .setup(CoachBilling)
    .setup(PerformBilling)
    .setup(Maintenance)
    .setup(Docs)
    .at("/add-to-calendar", ensureUser, ensurePaid, rill().setup(AddToCalendar))
    .get(redirect("/404"));
};

export default Views;
